import { FC, ReactNode, useEffect, useState, useRef } from "react";

import { useNavigate } from "react-router-dom";
import { useAppDispatch, useAppSelector } from "redux/hooks";
import { setMenuClick, setPreviousMenuClick } from "redux/slices/StepSlice";
import {
  Hambuger,
  List,
  ListItem,
  ListItemMenu,
  NavigationMenu,
  NavigationMenuExpand,
  NavigationWrapper,
} from "./Menu.styles";

type DynamicDiv = {
  isNavExpanded: boolean;
  children: ReactNode;
};

const DynamicDiv: FC<DynamicDiv> = ({ isNavExpanded, children }) => {
  return isNavExpanded ? (
    <NavigationMenuExpand>{children}</NavigationMenuExpand>
  ) : (
    <NavigationMenu>{children}</NavigationMenu>
  );
};

type HamburgerProps = {
  menuList: any;
};
const Hamburger: FC<HamburgerProps> = ({ menuList }) => {
  const navigate = useNavigate();
  const dispatch = useAppDispatch();

  const prevMenuClickRef = useRef<number>(0);
  const [mElement, setMElement] = useState<number>(0);
  const [isNavExpanded, setIsNavExpanded] = useState(false);
  const { menuClickId } = useAppSelector((state) => state.step);

  const ClickMenu = (e: any, m: any) => {
    e.preventDefault();
    if (m.menuLink?.state) {
      navigate(m.menuLink.link, {
        state: { ...m.menuLink.state },
      });
    } else {
      navigate(m.menuLink.link);
    }
    dispatch(setMenuClick(m.id));
    dispatch(setPreviousMenuClick(prevMenuClickRef.current));
    setIsNavExpanded(!isNavExpanded);
  };

  useEffect(() => {
    prevMenuClickRef.current = mElement;
    setMElement(menuClickId);
  }, [menuClickId, setMElement, mElement]);

  return (
    <NavigationWrapper>
      <Hambuger
        onClick={() => {
          setIsNavExpanded(!isNavExpanded);
        }}
      >
        <svg
          xmlns='http://www.w3.org/2000/svg'
          viewBox='0 0 20 20'
          fill='currentColor'
        >
          <path
            fillRule='evenodd'
            d='M3 5a1 1 0 011-1h12a1 1 0 110 2H4a1 1 0 01-1-1zM3 10a1 1 0 011-1h12a1 1 0 110 2H4a1 1 0 01-1-1zM3 15a1 1 0 011-1h12a1 1 0 110 2H4a1 1 0 01-1-1z'
            clipRule='evenodd'
          />
        </svg>
      </Hambuger>
      <DynamicDiv isNavExpanded={isNavExpanded}>
        <List>
          {menuList.map((m: any) => (
            <ListItem
              key={m.menuName}
              style={{
                borderBottom: `${
                  m.id !== 0 && m.id === mElement ? "4px solid #e0e0e0" : ""
                }`,
              }}
            >
              <ListItemMenu onClick={(e: any) => ClickMenu(e, m)}>
                {m.menuName}
              </ListItemMenu>
            </ListItem>
          ))}
        </List>
      </DynamicDiv>
    </NavigationWrapper>
  );
};

export default Hamburger;
